import script from "./BaseSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseSelect.vue?vue&type=script&setup=true&lang=ts"

import "./BaseSelect.vue?vue&type=style&index=0&id=2952306d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2952306d"]])

export default __exports__